import { useState } from "react";
import axios from "axios";

export default function InterviewSessionsChat({ interviewId }) {
  const [chatOpen, setChatOpen] = useState(false);
  const [messages, setMessages] = useState([]); // {role: "user"|"assistant", content: string}
  const [input, setInput] = useState("");

  const sendMessage = async () => {
    if (!input.trim()) return;
    const userMsg = { role: "user", content: input };
    setMessages(prev => [...prev, userMsg]);
    setInput("");
    try {
        const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/interviews/${interviewId}/qa`,
        { message: input }
        );
        const aiMsg = { role: "assistant", content: res.data.answer };
        setMessages(prev => [...prev, aiMsg]);
    } catch {
        setMessages(prev => [...prev, { role: "assistant", content: "Error fetching answer." }]);
    }
    };


  return (
    <>
      {/* Floating button */}
      <button
        onClick={() => setChatOpen(!chatOpen)}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          background: "var(--accent)",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          fontSize: "24px"
        }}
        title="Ask about sessions"
      >
        💬
      </button>

      {/* Chat panel */}
      {chatOpen && (
        <div className="chat-panel">
            <div className="chat-header">Sessions Q&A</div>
            <div className="chat-body">
            {messages.map((m,i)=>(
                <div key={i} className={`chat-msg ${m.role}`}>
                {m.content}
                </div>
            ))}
            </div>
            <div className="chat-input">
            <input value={input} onChange={e=>setInput(e.target.value)} placeholder="Ask a question..." />
            <button onClick={sendMessage}>Send</button>
            </div>
        </div>
        )}

    </>
  );
}
